import { Errors } from "io-ts"
import { failure } from "io-ts/PathReporter"
import * as ParseResult from "effect/ParseResult"

export type FatalError = {
    type: "Fatal"
    message: string
    data?: unknown
    error?: Error
}

export type TransientError = {
    type: "Transient"
    message: string
    data?: unknown
    error?: Error
}

export type GenericError = FatalError | TransientError

const genericError = (type: GenericError["type"], message: string, error?: Error, data?: unknown): GenericError => ({
    type,
    message,
    ...(error !== undefined ? { error } : {}),
    ...(data !== undefined ? { data } : {}),
})

export const fatal = (message: string, error?: Error, data?: unknown) => genericError("Fatal", message, error, data)
export const transient = (message: string, error?: Error, data?: unknown): GenericError =>
    genericError("Transient", message, error, data)

export const fromError =
    (message: string, data?: unknown) =>
    (error: Error): GenericError =>
        fatal(message, error, data)

export const fromUnknown =
    (message: string, data?: unknown) =>
    (error: unknown): GenericError =>
        genericError("Fatal", message, error instanceof Error ? error : undefined, {
            data,
            error: !(error instanceof Error) ? error : undefined,
        })

export const fromValidation =
    (message: string, data?: unknown) =>
    (errors: Errors): GenericError =>
        fatal(message, undefined, { ...(data ?? {}), validations: failure(errors) })

export const fromParseError =
    (message: string, data?: unknown) =>
    (parseError: ParseResult.ParseError): GenericError =>
        fatal(message, undefined, { ...(data ?? {}), validations: parseError.toString() })

export { genericError as new }
